export default[
    {
        path: '/cirugia',
        component: () => import(/* webpackChunkName: "cirugia" */ '@/views/Cirugia.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_PACIENTES'],
        },
        children:[
            {
                path:'/',
                name:'cirugia',
                component: () => import(/* webpackChunkName: "cirugiaMain" */ '@/views/cirugia/ListCirugia.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'create',
                name:'cirugiaCreate',
                component: () => import(/* webpackChunkName: "cirugiaCreate" */ '@/views/cirugia/CreateCirugia.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'atencion/:id',
                name:'cirugiasAtencion',
                component: () => import(/* webpackChunkName: "cirugiasAtencion" */ '@/views/cirugia/DetalleCirugia.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'record',
                name:'cirugiaRecord',
                component: () => import(/* webpackChunkName: "cirugiaRecord" */ '@/views/cirugia/RecordCirugia.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
        ]
    }
]